module.exports = __webpack_public_path__ + "img/softIndexGreen.50a94573.png";